import CityPageTemplate from "../city-template/CityPageTemplate";
import { houghtonConfig } from "./data";

export default function HoughtonPage() {
  return <CityPageTemplate config={houghtonConfig} />;
}